import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  toggle(event) {
    event.preventDefault()

    const url = this.element.dataset.favoriteUrl
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const request = new XMLHttpRequest()
    request.open("PATCH", url, true)
    request.setRequestHeader("Accept", "application/json")
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest")

    if (csrfToken) {
      request.setRequestHeader("X-CSRF-Token", csrfToken)
    }

    request.onload = () => {
      if (request.status < 200 || request.status >= 300) {
        console.error("Favorite toggle failed", request.status, request.responseText)
        return
      }

      const data = JSON.parse(request.responseText)
      this.updateIcon(data.favorite)
    }

    request.onerror = () => {
      console.error("Favorite toggle request failed")
    }

    request.send()
  }

  updateIcon(isFavorite) {
    if (isFavorite) {
      this.iconTarget.textContent = "★"
      this.iconTarget.classList.remove("text-gray-300")
      this.iconTarget.classList.add("text-yellow-500")
      this.element.setAttribute("title", "Remove from favorites")
    } else {
      this.iconTarget.textContent = "☆"
      this.iconTarget.classList.remove("text-yellow-500")
      this.iconTarget.classList.add("text-gray-300")
      this.element.setAttribute("title", "Add to favorites")
    }
  }
}